/**
 * MarkdownContent Component - Styled markdown renderer
 *
 * Wrapper around ReactMarkdown with:
 * - Jet-age aesthetic typography
 * - External links open in new tab
 * - Image sizing constraints
 * - Code block styling
 */

import React from 'react';
import ReactMarkdown from 'react-markdown';
import { fallbackMarkdownTables } from '../../utils/markdownTables';
import './MarkdownContent.css';

/**
 * Custom link renderer - opens external links in new tab
 */
const LinkRenderer = ({ href, children }) => {
  const isExternal = href && (href.startsWith('http://') || href.startsWith('https://'));

  if (isExternal) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  }

  return <a href={href}>{children}</a>;
};

/**
 * Custom image renderer - constrained sizing
 */
const ImageRenderer = ({ src, alt }) => {
  return (
    <img
      src={src}
      alt={alt || ''}
      className="markdown-content__image"
      loading="lazy"
    />
  );
};

function MarkdownContent({ content }) {
  if (!content) return null;

  return (
    <div className="markdown-content">
      <ReactMarkdown
        components={{
          a: LinkRenderer,
          img: ImageRenderer,
        }}
      >
        {fallbackMarkdownTables(content)}
      </ReactMarkdown>
    </div>
  );
}

export default MarkdownContent;
